import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Collapse from "@mui/material/Collapse";
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DefaultNavbarDropdown({
  name,
  icon,
  active,
  children,
  collapseStatus,
  light,
  href,
  route,
  collapse,
  ...rest
}) {
  const linkComponent = {
    component: "a",
    href,
    target: "_blank",
    rel: "noreferrer",
  };

  const routeComponent = {
    component: Link,
    to: route,
  };

  return (
    <>
      <MKBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        borderRadius={3}
        sx={{
          alignItems: "center",  
          justifyContent: "center",    
          cursor: "pointer",
          userSelect: "none",
          transition: "all 0.18s cubic-bezier(.4,0,.2,1)",
          "&:hover": {
            boxShadow: "0 2px 8px 0 rgba(0,54,31,0.08)",
            zIndex: 10,
            borderRadius: 6,
            transform: "scale(1.035)",
            borderBottom: "2.5px solid #00361F",
          },
          ...(active && {
            backgroundColor: "#00361F",
            color: "#fff",
            borderRadius: 6,
            "& .MuiTypography-root, & .MuiSvgIcon-root": {
              color: "#fff !important",
              fontWeight: 700,
            },
          }),
        }}
        {...rest}
        {...(route && routeComponent)}
        {...(href && linkComponent)}
      >
        <MKTypography
          variant="body1"
          lineHeight={1}
          color="inherit"
          sx={{
            alignSelf: "center", "& *": { verticalAlign: "center" },
            fontSize: 15,
            opacity: 0.9,
            marginLeft: 1,
            marginRight: 1,
          }}
        >
          {icon} 
        </MKTypography>
        <MKTypography
          variant="button"
          fontWeight="bold"
          color={light ? "white" : "dark"}
          sx={{
            letterSpacing: "0.05em",
            textAlign: "center",
            
            textTransform: "uppercase",
            fontFamily: "'Exo 2', sans-serif",
          }}
        >
          {name}
        </MKTypography>
        <MKTypography variant="body1" color={light ? "white" : "dark"} ml="auto">
          <Icon sx={{ fontWeight: "normal", verticalAlign: "middle" }}>
            {collapse && "keyboard_arrow_down"}
          </Icon>
        </MKTypography>
      </MKBox>
      {children && (
        <Collapse in={Boolean(collapseStatus)} timeout={400} unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

DefaultNavbarDropdown.defaultProps = {
  active: false,
  children: false,
  collapseStatus: false,
  light: false,
  href: "",
  route: "",
};

DefaultNavbarDropdown.propTypes = {
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  children: PropTypes.node,
  collapseStatus: PropTypes.bool,
  light: PropTypes.bool,
  href: PropTypes.string,
  route: PropTypes.string,
  collapse: PropTypes.bool.isRequired,
};

export default DefaultNavbarDropdown;
